<template>
	<div id="printB2bLabelSection" class="printB2bLabelSection w-full">
		<div v-for="(groupItem, idx) in order.b2BOrderGroupItems" :key="idx" class="print-page h-full">
			<div class="flex flex-row w-full h-full">
				<div class="flex w-4/12 flex-col items-center justify-center h-full">
					<span class="text-3xl font-bold mb-4">{{ order.timeSlot?.startTime }}</span>
					<QrcodeVue
						v-if="groupItem.hasQrCode"
						:value="groupItem.order.codeId"
						class="mb-4"
						:size="130"
						level="H"
						foreground="#000000"
						renderAs="svg"
						:image-settings="{
							src: qrLogo,
							width: 25,
							height: 25,
						}"
					/>
					<img
						v-else
						:src="b2bLogoBlack"
						alt="B2B Logo"
						class="mb-4 p-4 border-1 rounded-md ml-2"
						style="width: 115px; height: 115px"
					/>
				</div>
				<div class="divider-horizontal" />
				<div class="flex flex-col justify-center w-6/12">
					<div class="p-3 h-full place-content-end">
						<div class="flex flex-col w-full">
							<span class="text-3xl font-bold whitespace-nowrap truncate">{{
								formattedRestaurantName
							}}</span>
							<span class="text-2xl font-bold flex-1 truncate whitespace-nowrap">{{
								groupItem.code
							}}</span>
							<span class="text-xl font-bold flex-1 truncate whitespace-nowrap text-right">
								{{ groupItem.employeeFirstName }} {{ groupItem.employeeLastName }}
							</span>
						</div>
					</div>
					<div class="divider mb-1" />
					<div class="relative pt-2 h-full">
						<div
							v-for="(item, index) in groupItem.order.items.slice(0, 3)"
							:key="index"
							class="flex items-center justify-between gap-4 p-3"
							style="line-height: 0.75rem;"
						>
							<span class="truncate whitespace-nowrap font-semibold text-xl pb-2"
								>x{{ item.quantity }} {{ item.menuItem?.itemName }}
								<span v-if="groupItem.order.items.length > 3 && index === 2">...</span>
							</span>
						</div>
						<span
							v-if="order.b2BOrderGroupItems.length > 1"
							class="absolute right-0 bottom-0 px-2 font-semibold text-xl italic"
							>{{ idx + 1 }}/{{ order.b2BOrderGroupItems.length }}</span
						>
					</div>
				</div>
				<div class="divider-horizontal" />
				<div class="flex flex-col items-center justify-center w-2/12 rotated-text">
					<span class="text-4xl font-bold whitespace-nowrap truncate w-48 text-center"
						>{{ groupItem.code }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qrLogo from '@/assets/images/qrLogo.svg';
	import b2bLogoBlack from '@/assets/images/b2b_logo_black.svg';
	import QrcodeVue from 'qrcode.vue';

	export default {
		name: 'PrintB2bLabelModal',
		components: { QrcodeVue },
		data: () => ({
			qrLogo,
			b2bLogoBlack,
			order: {
				b2BOrderGroupItems: [],
				business: {},
				timeSlot: {},
				hasQrCode: false,
			},
		}),
		computed: {
			formattedRestaurantName() {
				if (!this.order.business?.restaurantName) {
					return '';
				}
				const name = this.order.business.restaurantName.toLowerCase().replace(/ at ?work$/, '');
				return name
					.split(' ')
					.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
					.join(' ');
			},
		},
		methods: {
			print() {
				const prtHtml = document.getElementById('printB2bLabelSection').innerHTML;
				let stylesHtml = '';
				for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
					stylesHtml += node.outerHTML;
				}
				const WinPrint = window.open(
					this.order.business.restaurantName,
					'',
					'left=0,top=0,width=700,height=600,toolbar=0,scrollbars=0,status=0'
				);
				WinPrint.document.write(`<!DOCTYPE html>
      <html lang="en">
        <head>
          <title>Print Order</title>
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);
				WinPrint.document.close();
				const imgElements = Array.from(WinPrint.document.images);
				const loadPromises = imgElements.map((img) =>
					img.complete
						? Promise.resolve()
						: new Promise((res) => {
								img.onload = res;
								img.onerror = res;
						  })
				);

				Promise.all(loadPromises).then(() => {
					WinPrint.focus();
					WinPrint.print();
					WinPrint.close();
				});
			},
		},
		mounted() {
			this.emitter.on('printB2bLabel', (order) => {
				this.order = order;
				this.$nextTick(() => {
					this.print();
				});
			});
		},
		beforeUnmount() {
			this.emitter.off('printB2bLabel', null);
		},
	};
</script>

<style lang="scss" scoped>
	.rotated-text {
		transform: rotate(-90deg);
	}

	.divider {
		border-bottom: 1px dashed black;
	}

	.divider-horizontal {
		border-right: 1px dashed black;
	}

	.printB2bLabelSection {
		display: none;
	}
	@media print {
		.printB2bLabelSection {
			display: block !important;
		}
		.print-page {
			page-break-after: always;
			height: 100vh;
		}
		.print-page:last-child {
			page-break-after: auto;
		}
	}
</style>
